import { createSelector } from 'reselect';
import { getPasswordResetState } from 'src/modules/password-reset/selectors/getPasswordResetState';

export const getPasswordResetValid = createSelector([
  getPasswordResetState,
], (state) => state.token !== null);
